import { useMemo, useContext, Fragment } from 'react';

import { Stack, Typography, Divider } from '@mui/material';

import FieldWithActions from 'pages/ConfigurationsPage/components/FieldWithActions';

import TitleIcon from 'components/Icons/titleIcon';
import PriorityFlagIcon from 'components/Icons/PriorityFlagIcon';
import CategoryIcon from 'components/Icons/categoryIcon';
import LocationIcon from 'components/Icons/locationIcon';
import AssetsIcon from 'components/Icons/sidebarIcons/assetsIcon';
import ParagraphIcon from 'components/Icons/paragraphIcon';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';

import { RequestConfigContext } from '../context';

const FormFields = () => {
  const ctx = useContext(RequestConfigContext);

  const form = useMemo(() => {
    const config = ctx?.config;
    const fields = [
      {
        key: 'title',
        label: 'Request Title',
        icon: <TitleIcon />,
        disabled: true,
      },
      {
        key: 'priority',
        label: 'Priority',
        icon: <PriorityFlagIcon />,
      },
      {
        key: 'CategoryId',
        label: 'Category',
        icon: <CategoryIcon />,
      },
      {
        key: 'LocationId',
        label: 'Location',
        icon: <LocationIcon />,
      },
      {
        key: 'AssetId',
        label: 'Asset',
        icon: <AssetsIcon />,
      },
      {
        key: 'description',
        label: 'Description',
        icon: <ParagraphIcon sx={{ p: '1px' }} />,
      },
      {
        key: 'attachments',
        label: 'Attachment',
        icon: <AttachFileOutlinedIcon sx={{ rotate: '45deg' }} />,
      },
    ];

    return fields.map((field) => ({
      ...field,
      visibility: config?.fields[field.key],
    }));
  }, [ctx?.config]);

  const handleUpdateVisibility = (field, visibility: string) => {
    ctx?.handleUpdateFieldVisibility(field.key, visibility);
  };

  return (
    <Stack
      direction={'row'}
      gap={'50px'}
      margin={'8px 24px 0px 24px'}
      borderBottom={'1px solid rgba(238, 238, 238, 1)'}
      paddingBottom={'20px'}
    >
      <Stack gap={'2px'}>
        <Typography fontSize={14} fontWeight={700} color={'#212121'}>
          Request Form Fields
        </Typography>
        <Typography fontSize={12} fontWeight={400} color={'#616161'}>
          Customize the form fields as per your requirements.
        </Typography>
      </Stack>
      <Stack width={'600px'}>
        {form?.map((field, idx) => (
          <Fragment>
            <FieldWithActions
              icon={field.icon}
              label={field.label}
              visibility={field.visibility}
              disabled={field.disabled}
              onVisibilityChange={(visibility) =>
                handleUpdateVisibility(field, visibility)
              }
            />
            {idx !== form.length - 1 && <Divider sx={{ my: '8px' }} />}
          </Fragment>
        ))}
      </Stack>
    </Stack>
  );
};

export default FormFields;
